import { useEffect, useState } from 'react';
import { getAnalyticsConsent, setAnalyticsConsent } from '@/lib/consent';
import { initPosthog, disablePosthog, initCookielessPosthog } from '@/lib/posthog';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const current = getAnalyticsConsent();
    if (current === null) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-3 right-3 z-50 max-w-sm w-[92%] rounded-sm border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 p-3 shadow-md">
      <div className="text-xs">
        Help us improve our product. Allow analytics cookies?
      </div>
      <div className="mt-2 flex gap-2 justify-end">
        <button
          className="px-2 py-1 text-xs rounded border"
          onClick={() => {
            setAnalyticsConsent(false);
            // Start minimal, cookieless pageview only (no cookies, no autocapture)
            initCookielessPosthog();
            setVisible(false);
          }}
        >
          No
        </button>
        <button
          className="px-2 py-1 text-xs rounded bg-primary text-primary-foreground"
          onClick={() => {
            setAnalyticsConsent(true);
            initPosthog();
            setVisible(false);
          }}
        >
          Yes, no problem
        </button>
      </div>
    </div>
  );
}


